import Skeleton from '../ui/Skeleton';

export default function LoadingSpinner({ size = 'md', className = '' }) {
  const sizeClasses = {
    sm: 'w-5 h-5 border-2',
    md: 'w-8 h-8 border-3',
    lg: 'w-12 h-12 border-4',
    xl: 'w-16 h-16 border-4'
  }

  return (
    <div className={`flex items-center justify-center ${className}`}>
      <div
        className={`${sizeClasses[size]} border-ink/15 border-t-primary-500 rounded-full animate-spin`}
        style={{ borderTopWidth: size === 'sm' ? 2 : 3 }}
      />
    </div>
  )
}

export function FullPageSpinner() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-4" role="status">
      <LoadingSpinner size="xl" />
      <p className="text-ink-400 animate-pulse">Se încarcă...</p>
    </div>
  )
}

// Mirrors MarketplaceCard's anatomy (square image + flush text lines,
// no panel) so the loading grid matches the cards that replace it.
export function SkeletonCard() {
  return (
    <div>
      <Skeleton className="aspect-square" rounded="rounded-2xl" />
      <div className="mt-2 space-y-1.5">
        <Skeleton className="h-4 w-3/4" rounded="rounded" />
        <Skeleton className="h-3 w-1/2" rounded="rounded" />
      </div>
    </div>
  )
}
